/*
 *	services v1.0.0 
 *	(c) 2019 Henk Salomons
 *	
 *	responsible for fetching data from and to the amazilia backoffice.
 */

import { EventBus } from './Services';
import Vue from 'vue';

var shoppingCartService = function () {

    var _shoppingCartLoading = false;
    var _timer = null;

    var _shoppingCart = {
        model: {
            items: [],									              // the cart items
            subTotal: {},								              // the subtotal as an amazilia price object
            total: {},									              // the total as an amazilia price object
            estimateShipping: { shippingRate: null },	// the estimate shipping object			
            totalItems: 0								              // the calculated total items (items * quantity)
        },
        continueButtonDisabled: false,              // is the continue button disabled or not (in case off pending dialog choises)
        shoppingDisabled: false,                   // a value indicating whether the customer can complete the checkout  (no available times for example)
        message: '',
        loading: false,									            // a value indicating whether the data is being loaded or not
        dirty: false                                // a value indication if the shopping cart needs synchronisation with the server.
    };

    /**
     * function syncs the result from the server with the current basket
    * @param {any} data The data from the server
     */
    function updateBasket(data) {

        // $(window.Amazilia).on('addedToBasket', function (e, data) {

        //tryMobileAnimation($(".icon-basket"), "pulse1");
        //setIconCartTogglerQuantity();

        // display error message, if any
        var html = '';
        if (!data.success) {
            html = '<ul class="cart-warnings">';
            for (var i in data.message) {
                html += '<li>' + data.message[i] + '</li>';
            }
            html += '</ul>';

            $(html).modal();
            return;
        }

        // display message (if any)
        if (data.sections['updateaddedtocarthtml'] && data.sections['updateaddedtocarthtml'].length > 10) {
            html = data.updateaddedtocarthtml;
            $(html).modal();
        }

        _shoppingCart.dirty = false;
       
        if (!_shoppingCart.model.items.find(function (a) { return a.pending; })) {

            // shortcut
            _shoppingCart.model = data.data;

            // add removed property for reactivenes of vue
            _shoppingCart.model.items.forEach(function (a) { Vue.set(a, 'removed', !!a.removed); });

        } else {
            // still pending, use client cart, roundtrip to server is pending or scheduled
        }

        _shoppingbagCalculateTotals(_shoppingCart.model);

        // set the new cart items to the model
        // _shoppingCart.model = data.data;
        _shoppingCart.loading = false;

        _adjustAllergies();

        storeToLocalStorage();
    }

    /**
     * Creates a new shopping bag item
     * @param {any} product the Amazilia product
     * @param {any} quantity the quantity
     * @param {string} contentPriceAlias the contentpricealias
     * @returns {object} the new shopping bag item
     */
    function createShoppingBagItem(product, quantity, contentPriceAlias) {

        var shoppingBagItem = {
            "children": [],
            "productId": product.id,
            "contentPriceAlias": product.contentPriceAlias,
            "productName": product.name,
            "unitPrice": product.price,
            "subTotal": JSON.parse(JSON.stringify(product.price)),
            "product": product,
            "quantity": quantity,
            "addedToCart": true,
            "removed": false,
            "pending": true,
            discount: {},
            appliedDiscounts : []
        };

        shoppingBagItem.subTotal.priceInclTax = shoppingBagItem.unitPrice.priceInclTax * shoppingBagItem.quantity;
        shoppingBagItem.subTotal.priceExclTax = shoppingBagItem.unitPrice.priceExclTax * shoppingBagItem.quantity;

        return shoppingBagItem;
    }

    /*
    function removeExcludedItems(items) {

        items = items.filter(a => {
            return !a.product.content.excludeOrder;
        });

        for (var keyId in items) {
            let item = items[keyId];
            if (item.children && item.children.length)
                item.children = removeExcludedItems(item.children);
        }

        return items;
    }
    */

    var _init = function () {

        /**
         * Global add-to-basket handler, sent items to api
         */
        EventBus.$on('add-to-basket', function (items) {

            _shoppingCart.loading = true;


            //  items = removeExcludedItems(items);

            // add the root items to the shopping bag.
            for (var keyId in items) {
                let item = items[keyId];


                // find out if an item with the same children already exists
                let shoppingBagItem = FindShoppingBagItem(item);

                if (shoppingBagItem) {
                    _increaseChildren(shoppingBagItem, shoppingBagItem.quantity, shoppingBagItem.quantity + item.quantity);
                    shoppingBagItem.quantity += item.quantity;
                    shoppingBagItem.pending = true;
                    shoppingBagItem.removed = false;
                } else {
                    // create shopping bag item
                    shoppingBagItem = createShoppingBagItem(item.product, item.quantity);
                    _shoppingCart.model.items.push(shoppingBagItem);

                    // add children
                    _addChildren(item, shoppingBagItem);
                }

                // GTM e-Commecerce
                const gtmInstance = window.vwaGtmEcommerceInstance;
                if (gtmInstance && typeof gtmInstance.AddToCart === 'function') {
                    gtmInstance.AddToCart(item);
                } else {
                    console.warn('GTM AddToCart niet beschikbaar.');
                }

            }

            _shoppingbagCalculateTotals(_shoppingCart.model);
            _calculatePrice(_shoppingCart.model);

            _shoppingCart.dirty = true;

            if (_timer) {
                window.clearTimeout(_timer);
            }
            _timer = window.setTimeout(SyncShoppingBag, 1);

        });

        function _addChildren(item, parent) {
            for (let key in item.children) {

                var prepMethod = item.children[key];

                if (prepMethod.quantity > 0) {
                    let shoppingBagPrepMethod = createShoppingBagItem(prepMethod.product, prepMethod.quantity);
                    parent.children.push(shoppingBagPrepMethod);

                    if (prepMethod.children && prepMethod.children.length) {
                        _addChildren(prepMethod, shoppingBagPrepMethod);
                    }
                }
            }
        }

        function _increaseChildren(item, rootQ, newQ) {
            for (let key in item.children) {
                var prepMethod = item.children[key];
                var subQuantity = (prepMethod.quantity / rootQ) * newQ;
                prepMethod.quantity = subQuantity;
                _increaseChildren(prepMethod, rootQ, subQuantity);
            }
        }

        window.addEventListener("online", function (e) {
            // _loadDeliveryTime();
            SyncShoppingBag();
        }, false);

        // _loadDeliveryTime();

        loadFromLocalStorage();
    };
    
    /**
   * Search for an item in the shoppingbag with the same children fingerprint
   * @param {any} searchItem the item to search
   * @param {any} key the property to search in
   * @returns {object} the shoppingbag item or null
   */
    function FindShoppingBagItem(searchItem) {

        let id = searchItem.productId || searchItem.product.id;
        let item = findInChildren(_shoppingCart.model.items);

        function findInChildren(itemList) {
            // root items
            for (let itemKey in itemList) {
                let foundItem = itemList[itemKey];
                if (foundItem.productId === id) {
                    if (_childrenMatch(searchItem.children, searchItem.quantity, foundItem.children, foundItem.quantity)) {
                        return foundItem;
                    }
                }
            }

            // root items
            for (let itemKey in itemList) {
                let foundItem = itemList[itemKey];
                // search also in the children of the root discount groups, note!, this is not a product but a virtual shopping cart item.
                if (foundItem.shoppingCartTypeId == 8) {
                    return findInChildren(foundItem.children);
                }
            }
        }

        function _childrenMatch(itemsSearch, searchParentQuantity, itemsCart, parentQuantity) {

            if (typeof itemsSearch !== typeof itemsSearch) {
                return false;
            }

            if (!itemsSearch) {
                return true;
            }

            if (itemsSearch.length !== itemsCart.length) {
                return false;
            }

            if (!itemsSearch.length) {
                return true;
            }

            var match = false;
            var cartItem = null;
            var searchcontentPriceAlias;
            var itemsSearchId;
            var searchItem;

            for (var childKey in itemsCart) {

                cartItem = itemsCart[childKey];
                match = false;

                for (var searchKey in itemsSearch) {
                    searchItem = itemsSearch[searchKey];
                    searchcontentPriceAlias = searchItem.contentPriceAlias || searchItem.product.contentPriceAlias;
                    itemsSearchId = searchItem.productId || searchItem.product.id;
                    if (cartItem.productId === itemsSearchId && cartItem.contentPriceAlias === searchcontentPriceAlias && (cartItem.quantity / parentQuantity) === (searchItem.quantity / searchParentQuantity)) {
                        match = _childrenMatch(searchItem.children, searchItem.quantity, cartItem.children, cartItem.quantity);
                    }
                }
                if (!match)
                    break;
            }

            return match;
        }

        return item;
    }


    function _flatenShoppingBagItems(itemList, returnListRef, groupedDiscount) {

        var returnList = returnListRef || [];
     
        // root items
        for (var itemKey in itemList) {

            var foundItem = itemList[itemKey];

            // search also in the children of the root discount groups, note!, this is not a product but a virtual shopping cart item.
            if (foundItem.shoppingCartTypeId == 8) {
                _flatenShoppingBagItems(foundItem.children, returnList, true);
            }
            else {

                // find items in the returnlist with the same productId, merge them and add the quantity
                // Check if an item with the same productId already exists in returnList
                //var existingItem = null;
                returnList.push(foundItem);

                //if (groupedDiscount === true) {
                //    existingItem = returnList.find(function (item) {
                //        return item.productId === foundItem.productId;
                //    });

                //    if (existingItem) {
                //        // Merge quantities
                //        existingItem.quantity += foundItem.quantity;
                //        existingItem.pending = existingItem.pending || foundItem.pending;
                //    } else {
                //        // create a deep copy of the item to avoid referencing the original object
                //        returnList.push(JSON.parse(JSON.stringify(foundItem)));
                //    }
                //} else {
                //    returnList.push(foundItem);
                //}
                
            }
        }



        return returnList;
    }


    var _pendingSync = false;

    /**
     * Synchronises the offline shopping bag to the server
     * 
     **/
    function SyncShoppingBag() {

        let shoppingBagItemsToSync = [];

        if (navigator.onLine) {

            // check if roundtrip to server is still pending.
            if (_pendingSync) {
                _timer = window.setTimeout(SyncShoppingBag, 200);
                return;
            }

            //EmptyBasketItems
            if (_shoppingCart.removeAll) {
                _shoppingCart.removeAll = false;
                _pendingSync = true;
                _shoppingCart.loading = true;
                window.Amazilia.sendEmptyBasketItems('ShoppingCart', null, function (data) {
                    _pendingSync = false;
                    updateBasket(data);
                });
                return;
            }

            // special action for the discount group shoppingcart item..
            var items = _flatenShoppingBagItems(_shoppingCart.model.items);
           
            for (var key in items) {
               let item = items[key];

                if (item.pending) {
                    // main syncitem item.
                    let amzShoppingbagRootItem = { ItemID: item.productId, Quantity: item.quantity, Children: [], ContentPriceAlias: item.contentPriceAlias, ShoppingCartID: item.shoppingCartID };
                    shoppingBagItemsToSync.push(amzShoppingbagRootItem);
                    _addChildren(item, amzShoppingbagRootItem);

                    if (item.removed) {
                        amzShoppingbagRootItem.Remove = true;
                    }

                    item.pending = false;
                    item.sending = true;
                }
            }
                
            if (shoppingBagItemsToSync.length) {
                _pendingSync = true;
                _shoppingCart.loading = true;
              
                for (var key in _shoppingCart.model.items) {
                    let item = _shoppingCart.model.items[key];
                    item.pending = false;
                }

                window.Amazilia.sendUpdateItemsForm(shoppingBagItemsToSync, null, function (data) {
                    _pendingSync = false;
                    updateBasket(data);
                });
            }
        } else {
            //window.addEventListener("online", function (e) {
            //  SyncShoppingBag();
            //}, false);
        }

     

        /**
         * Adds the items children to the model send to the server.
         * @param {any} sourceItem the shopping cart item
         * @param {any} amzShoppingbagParent the Amazilia shoppingbag model
         */
        function _addChildren(sourceItem, amzShoppingbagParent) {

            // add preperation methods
            for (let key in sourceItem.children) {

                var shoppingBagChildItem = sourceItem.children[key];

                if (shoppingBagChildItem && shoppingBagChildItem.quantity > 0 || shoppingBagChildItem.pending) {
                    let syncItem = { ItemID: shoppingBagChildItem.productId, Quantity: shoppingBagChildItem.quantity, ContentPriceAlias: shoppingBagChildItem.contentPriceAlias, ShoppingCartID: shoppingBagChildItem.shoppingCartID };
                    amzShoppingbagParent.Children.push(syncItem);
                    if (shoppingBagChildItem.children) {
                        syncItem.Children = [];
                        _addChildren(shoppingBagChildItem, syncItem);
                    }
                    //AmaziliaOrderitems.push(prepItem);
                }
            }
        }
    }

    /**
     * Calculates the total items
     * @param {any} model the shopping bag model
     */
    function _shoppingbagCalculateTotals(model) {
        var total = 0;

        for (var key in model.items) {
            let item = model.items[key];
            item.removed = !!item.removed;
            if (!item.removed) {
                total += item.quantity;
            }
        }
        Vue.set(model, "totalItems", total);
    }

    function _adjustAllergies() {


        for (var key in _shoppingCart.model.items) {
            let item = _shoppingCart.model.items[key];

            if (!item.removed) {
                item.product.content.allergenen = item.product.content.allergenen || [];
                if (item.children && item.children.length) {
                    _doChildren(item, item.children);
                }
            }
        }

        function _doChildren(item, children) {
            for (var key in children) {
                var child = children[key];
                if (child) {
                    if (child.quantity > 0) {

                        // get allergies and loop to add to total, merge if needed
                        if (child.product.content.allergenen) {
                            child.product.content.allergenen.forEach(function (allergyId) {

                                if (item.product.content.allergenen.indexOf(allergyId) === -1) {
                                    item.product.content.allergenen.push(allergyId);
                                }

                                //if (item.allergyAdditions.indexOf(allergyId) === -1
                                //  && (!item.product.content.allergenen || item.product.content.allergenen.indexOf(allergyId) === -1)) {
                                //  item.allergyAdditions.push(allergyId);
                                //}
                            });
                        }

                    }
                    if (child.children && child.children.length) {
                        _doChildren(child.children);
                    }
                }
            }
        }
    }


    function _calculatePrice(model) {
        // do nothing, price calculation is done on the server..

    }

    /**
     * Calculates the prices for offline modus
     * @param {any} model the shopping bag model
     */
    function _calculatePrice_offline(model) {
        model.total.priceInclTax = model.estimateShipping && model.estimateShipping.shippingRate ? model.estimateShipping.shippingRate.priceInclTax : 0;
        model.compositeTotal.priceInclTax = 0;

        for (var key in model.items) {

            let item = model.items[key];
            item.removed = !!item.removed;

            if (!item.removed) {

                if (!item.discount.priceInclTax) {
                    item.subTotal.priceInclTax = item.unitPrice.priceInclTax * item.quantity;
                }

                model.total.priceInclTax += item.subTotal.priceInclTax;

                if (item.product.compositeProducts)
                    item.product.compositeProducts.forEach(a => {
                        model.compositeTotal.priceInclTax += a.price.priceInclTax * item.quantity;
                    });

                _calculateChildren(model, item);
            }
        }
    }

    function _calculateChildren(model, item) {

        for (var childKey in item.children) {
            var prepmethod = item.children[childKey];
            prepmethod.subTotal.priceInclTax = prepmethod.unitPrice.priceInclTax * prepmethod.quantity;
            model.total.priceInclTax += prepmethod.subTotal.priceInclTax;
            if (prepmethod.children && prepmethod.children.length) {
                _calculateChildren(model, prepmethod);
            }
        }

    }


    function _loadDeliveryTime(fnComplete, fnError) {

        var headers = {};
        headers.PwaDisableCache = 1;
        headers.CultureCode = window.pwa_currentCultureName;
        headers.StoreId = window.pwa_storeId;

        $.ajax({
            type: "POST",
            url: "/umbraco/Ordergo/ordergoCheckout/DeliveryTimeAsJson",
            headers: headers,
            error: function (ex) {
                if (typeof fnError == 'function') {
                    fnError(ex);
                }
            }
        })
            .done(function (jqXHROrData) {

                _shoppingCart.shoppingDisabled = jqXHROrData.ShoppingDisabled;
                _shoppingCart.message = jqXHROrData.Message;

                if (typeof fnComplete == 'function') {
                    fnComplete(jqXHROrData);
                }
                // _this.dirty = shoppingCartService.shoppingCart.dirty;
            });
    }


    function _loadTimeTable(dateFrom, dateTo, minuteInterval, fnComplete, fnError) {
        var headers = {};
        headers.PwaDisableCache = 1;
        headers.CultureCode = window.pwa_currentCultureName;
        headers.StoreId = window.pwa_storeId;
        $.ajax({
            type: "POST",
            url: "/umbraco/Ordergo/ordergoCheckout/DeliveryTimeTableAsJson",
            headers: headers,
            data: {
                dateFrom: dateFrom,
                dateTo: dateTo,
                interval: minuteInterval
            },
            error: function (ex) {
                if (typeof fnError == 'function') {
                    fnError(ex);
                }
            }
        }).done(function (jqXHROrData) {

            _shoppingCart.shoppingDisabled = jqXHROrData.ShoppingDisabled;
            _shoppingCart.message = jqXHROrData.Message;

            if (typeof fnComplete == 'function') {
                fnComplete(jqXHROrData);
            }
            // _this.dirty = shoppingCartService.shoppingCart.dirty;
        });
    }

    var loadFromLocalStorage = function () {

        if (localStorage.getItem('shoppingcart')) {
            try {
                _shoppingCart.model = JSON.parse(localStorage.getItem('shoppingcart'));
            } catch (e) {
                localStorage.removeItem('shoppingcart');
            }
        }

        return _shoppingCart;
    };

    var storeToLocalStorage = function () {
        const parsed = JSON.stringify(_shoppingCart.model);
        localStorage.setItem('shoppingcart', parsed);
    };

    function _posOrderSubmit() {

        function _doSubmit(resolve, reject) {

            if (_pendingSync) {
                _timer = window.setTimeout(_doSubmit, 500);
                return;
            }

            var url = '/umbraco/pos/Poscheckoutsurface/posordersubmit/';

            _pendingSync = true;

            var date = $('input[name=DesiredTimeDay]').val();

            window.Amazilia.sendForm({ 'event': 'confirmOrder', 'desiredTimeDay': date }, url, function (data) {
                _pendingSync = false;

                _shoppingCart.model.items = [];
                _shoppingCart.model.totalItems = 0;
                _shoppingCart.model.total.priceInclTax = 0;
                _shoppingCart.model.total.priceExclTax = 0;
                storeToLocalStorage();
                resolve(data);

            }, function () { reject(); });
        }

        return new Promise(function (resolve, reject) {
            _doSubmit(resolve, reject);
        });
    }

    function _getRequestHeaders() {
        var headers = {};
        headers.PwaDisableCache = 1;
        headers.CultureCode = window.pwa_currentCultureName;
        headers.StoreId = window.pwa_storeId;
        return headers;
    }

    _init();

    return {

        // Global shopping cart model
        shoppingCart: _shoppingCart,

        // checkout url, set in ordering.cshml
        checkoutLink: window.pwa_checkouturl,

        /**
         * Gets the shippingcart items
         * @param {function} error - error callback
         */
        loadShoppingCart: function (error) {
            var vm = this;

            // first sync!
            if (vm.shoppingCart.dirty) {
                SyncShoppingBag();
            }

            var headers = _getRequestHeaders();

            if (!_shoppingCartLoading) {
                vm.loading = true;
                _shoppingCartLoading = true;
                $.ajax('/umbraco/Amazilia/BasketSurface/JsonCart', { cache: false, headers: headers, complete: _complete, error: _error });
            }

            function _complete(result) {

                //console.log('* basket loaded');

                _shoppingCartLoading = false;
                vm.loading = false;

                if (result.status === 200 && result.responseJSON.success) {
                   
                    _shoppingbagCalculateTotals(result.responseJSON.data);
                    vm.shoppingCart.model = result.responseJSON.data;

                    _adjustAllergies();
                    storeToLocalStorage();
                    vm.shoppingCart.dirty = false;
                    vm.shoppingCart.loading = false;
                } else {
                    error(result);
                }
            }

            function _error(err) {
                vm.loading = false;
                _shoppingCartLoading = false;
                error(err);
            }
        },

        removeCartItem: function (item) {

            Vue.set(item, 'removed', true);
            item.pending = true;
            _shoppingCart.dirty = true;

            var oldq = item.quantity;
            item.quantity = 0;
            this.quantitychanged(item, oldq )
            
            // GTM e-Commecerce
            const gtmInstance = window.vwaGtmEcommerceInstance;
            if (gtmInstance && typeof gtmInstance.RemoveFromCart === 'function') {
                gtmInstance.RemoveFromCart(item, item.quantity);
            } else {
                console.warn('GTM RemoveFromCart niet beschikbaar.');
            }

            //if (_timer) {
            //    window.clearTimeout(_timer);
            //}
            //_timer = window.setTimeout(SyncShoppingBag, 1);

            //_shoppingbagCalculateTotals(_shoppingCart.model);
            //_calculatePrice(_shoppingCart.model);
            //storeToLocalStorage();

        },

        quantitychanged: function (item, oldQ) {
            item.pending = true;
            _shoppingCart.dirty = true;

            if (item.quantity <= 0) {
                Vue.set(item, 'removed', true);
               // this.removeCartItem(item);
               // return;
            }
          
            // add children
            for (let key in item.children) {

                var prepMethod = item.children[key];
                // parseint to avoid a double from appearing for some reason
                prepMethod.quantity = parseInt((prepMethod.quantity / oldQ) * item.quantity);

              
                    
                    prepMethod.pending = true;
               

                // add preperation methods
                for (let key2 in prepMethod.children) {
                    var prepMethod2 = prepMethod.children[key2];
                    // parseint to avoid a double from appearing for some reason
                    prepMethod2.quantity = parseInt((prepMethod2.quantity / oldQ) * item.quantity);
                    prepMethod2.pending = true;
                }

            }

            // GTM e-Commecerce
            const gtmInstance = window.vwaGtmEcommerceInstance;
            if (item.quantity < oldQ && gtmInstance && typeof gtmInstance.RemoveFromCart === 'function') {
                gtmInstance.RemoveFromCart(item, oldQ - item.quantity);
            }
            else if (item.quantity > oldQ && gtmInstance && typeof gtmInstance.AddToCart === 'function') {
                gtmInstance.AddToCart(item, item.quantity - oldQ);
            }
            else {
                console.warn('GTM e-Commerce request failed.');
            }

            if (_timer) {
                window.clearTimeout(_timer);
            }
            _timer = window.setTimeout(SyncShoppingBag, 500);

            _shoppingbagCalculateTotals(_shoppingCart.model);
            _calculatePrice(_shoppingCart.model);
            storeToLocalStorage();
        },

        /**
         * Emptys the shopping basket
         */
        emptyBasket: function () {
            _shoppingCart.dirty = true;
            _shoppingCart.removeAll = true;

            // set the items to deleted.
            for (var key in _shoppingCart.model.items) {
                let item = _shoppingCart.model.items[key];

                Vue.set(item, 'removed', true);
                Vue.set(item, 'quantity', 0);
                item.pending = true;

                // GTM e-Commecerce
                const gtmInstance = window.vwaGtmEcommerceInstance;
                if (gtmInstance && typeof gtmInstance.RemoveFromCart === 'function') {
                    gtmInstance.RemoveFromCart(item, item.quantity);
                } else {
                    console.warn('GTM RemoveFromCart niet beschikbaar.');
                }

            }
            _shoppingCart.model.totalItems = 0;
            _shoppingCart.model.total.priceInclTax = 0;
            _shoppingCart.model.subTotal.priceInclTax = 0;
            _shoppingCart.model.discountTotal = 0;
            _shoppingCart.model.willEarnRewardPoints = 0;
            _shoppingCart.model.displayRewardPoints = false;
            _shoppingCart.model.redeemedRewardPointsAmount = 0;
            _shoppingCart.model.estimateShipping.shippingRate.priceInclTax = 0;
            _shoppingCart.model.compositeTotal = 0;
            _shoppingCart.model.subTotalDiscount.priceInclTax = 0;
            _shoppingCart.model.appliedDiscounts = [];

            storeToLocalStorage();
            SyncShoppingBag();
        },

        setDisabled: function (disabled) {
            _shoppingCart.shoppingDisabled = disabled;
        },
        setMessage: function (message) {
            _shoppingCart.message = message;
        },

        loadDeliveryTime: function (fnComplete, fnError) {
            return _loadDeliveryTime(fnComplete, fnError);
        },

        loadTimeTable: function (fromDate, toDate, minuteInterval, fnComplete, fnError) {
            return _loadTimeTable(fromDate, toDate, minuteInterval, fnComplete, fnError);
        },

        posOrderSubmit: function () {
            return _posOrderSubmit();
        },

        setUseRewardPoints: function (rewardPoints) {

            var headers = _getRequestHeaders()
            var url = '/umbraco/UseRewardPoints/UseRewardPointsApi/UseRewardPoints?rewardPointsToUse=' + rewardPoints;
            _shoppingCart.loading = true;
            var _this = this;

            $.ajax(url, {
                headers: headers,
                complete: function (result) {
                    _this.loadShoppingCart();

                }, error: function (err) {
                    console.error(err)
                }
            });

        },

        applyCouponCode: function (couponCode, callback) {
            var headers = _getRequestHeaders();
            _shoppingCart.loading = true;
            var _this = this;
            $.ajax({
                type: "POST",
                url: '/umbraco/Amazilia/CheckoutSurface/VoucherCode',
                data: { voucherCode: couponCode, __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
                headers: headers,
                success: function (result) {
                    if (result.success) {
                        _this.loadShoppingCart();
                    } else {
                        _shoppingCart.loading = false;
                    }
                    if (callback) callback(result);
                },
                error: function (err) {
                    console.error(err);
                    _shoppingCart.loading = false;
                    if (callback) callback({ success: false, error: 'Er is een fout opgetreden.' });
                }
            });
        },

        removeCouponCode: function (couponCode) {
            var headers = _getRequestHeaders();
            _shoppingCart.loading = true;
            var _this = this;
            $.ajax({
                type: "POST",
                url: '/umbraco/Amazilia/CheckoutSurface/RemoveVoucherCode',
                data: { voucherCode: couponCode, __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
                headers: headers,
                complete: function (result) { _this.loadShoppingCart(); },
                error: function (err) { console.error(err); }
            });
        }


    };
}();


export default shoppingCartService;




// WEBPACK FOOTER //
// ./Vue/Src/Services/ShopingCartService.js